import Service from "./Service"

class ProductProjectService extends Service {

    findById = (id) => this.get(`/product-projects/${id}`)

    getNewIterationOptions = (id) => this.get(`/product-projects/${id}/iteration-options`)

    getIterationOptions = (id, iterationId) => this.get(`/product-projects/${id}/iteration-options/${iterationId}`)

    getSelectors = () => this.get("/product-projects/selectors")

    search = (queryParams) => this.getWithParams("/product-projects", queryParams)

    create = (request) => this.post("/product-projects", request)

    update = (id, request) => this.patch(`/product-projects/${id}`, request)

    changeProductImage = (id, fileId) => this.patch(`/product-projects/${id}/files/${fileId}`)

    delete = (id) => this.del(`/product-projects/${id}`)

    deleteFile = (id, fileId) => this.del(`/product-projects/${id}/files/${fileId}`)
}

const productProjectService = new ProductProjectService()
export default productProjectService